import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=14d7d547&"
import script from "./Access.vue?vue&type=script&lang=ts&"
export * from "./Access.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports